import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';

import Box from '@mui/material/Box';

import { useIsTouchDevice } from '../../../../hooks/useIsTouchDevice.hook';

import { Welcome } from '../../Welcome';
import { useDocumentEditorContext } from '../../contexts/DocumentEditorContext/hooks/useDocumentEditorContext.hook';
import type { Editable } from '../../types/editable.type';
import { ContentLockNotice } from '../../ContentLockNotice';

import { Section } from './Section';

export const SummaryTabPanel = () => {
  const { enrichedVirtualRoot } = useDocumentEditorContext<Editable>();

  const isTouchDevice = useIsTouchDevice();

  return (
    <Box sx={{ display: 'flex', flexGrow: 1 }}>
      {!enrichedVirtualRoot.subSections.length ? (
        <Welcome />
      ) : (
        <Box
          sx={{
            mt: 4,
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <ContentLockNotice />
          <DndProvider backend={isTouchDevice ? TouchBackend : HTML5Backend}>
            {enrichedVirtualRoot.subSections.map(
              (section, idx, subSections) => (
                <Section
                  isLastChild={idx === subSections.length - 1}
                  key={section._id}
                  section={section}
                  showTarget
                />
              ),
            )}
          </DndProvider>
        </Box>
      )}
    </Box>
  );
};
